<template>
  <v-col
    cols="12"
    sm="12"
    class="visit-container"
    @click="$emit('show-request-detail', visit.request_id)"
  >
    <v-card
      :style="{ opacity: isNavigating ? 0.7 : 1 }"
      style="border-radius: 0; padding: 12px"
    >
      <v-row style="margin: 0; margin-bottom: 12px">
        <v-col cols="5" style="padding: 0">
          <div :style="visitTypeStyle">{{ visit.visit_type.label }}</div>
        </v-col>
        <!-- ESCHEMAS -->
        <v-col
          v-if="$store.state.app_display_scheme"
          cols="1"
          style="
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <SchemeIcon :scheme="visit.scheme_name" class="icon-size" />
        </v-col>

        <v-col cols="3" style="padding: 0; display: flex; align-items: center">
          <div style="margin-left: 12px; font-weight: bold">
            ID: {{ visit.request_id }}
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          style="
            display: flex;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div style="margin-right: 24px">
            <b>HORA DE INICIO:</b> {{ visit.arrival_time }}
          </div>
        </v-col>
      </v-row>
      <v-row
        v-if="showDate"
        align="center"
        style="margin: 0 12px; text-transform: capitalize"
      >
        {{ formatDate(visit.visit_date) }}
      </v-row>
      <v-row
        v-if="$store.state.app_display_username && visit.client_fullname"
        align="center"
        style="margin: 0 12px; font-weight: bold"
      >
        {{ visit.client_fullname }}
      </v-row>
      <v-row
        align="center"
        style="font-weight: bold; text-transform: capitalize; margin: 0 0 12px"
      >
        {{ visit.service_name }}
      </v-row>
      <v-row>
        <v-col
          cols="12"
          style="
            display: flex;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div style="margin-right: 24px">
            <b>DOMICILIO:</b>
            <span style="text-transform: capitalize">
              {{ visit.request_address }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>
<script>
import moment from "moment";

import SchemeIcon from "./SchemeIcon.vue";

export default {
  props: {
    visit: Object,
    showDate: String,
    isNavigating: Boolean,
  },
  components: {
    SchemeIcon,
  },
  computed: {
    visitTypeStyle: function () {
      const style = `
        background-color:${this.visit.visit_type.backgroundColor};
        color:${this.visit.visit_type.color};
        padding: 6px;
        font-size: 14px;
        display: flex;
        justify-content: center;
      `;
      return style;
    },
  },
  methods: {
    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },
  },
};
</script>

<style scoped>
.visit-container {
  padding-inline: 12px !important;
}

@media (max-width: 959px) {
  .visit-container {
    padding: 12px 0;
    background: #eeeeee;
  }
}
.icon-size {
  max-width: 25px;
  max-height: 20px;
}
</style>
